const trackingUtils = require('od-modules/utils/tracking.utils');
const UiGoogleMap = require('od-modules/helpers/map/ui/hotel_result_list');
const commonParser = require('od-modules/parsers/dynpack_common');
const TRACKING_ACTIONS = {
    accommodationResultsMap: 'results_list_hotels_map',
    accommodationResults: 'results_list_hotels',
};
const TRACKING_LABELS = {
    openMap: 'map_open_all_hotels',
    clickMarker: 'hotel_click',
    clickCluster: 'map_click_bubble',
};
const MAP_OPTIONS = {
    offsetHeight: 60,
    minHeight: 400,
};
const CLUSTER_OPTIONS = {
    clusterCustomConfig: {
        minimumClusterSize: 5,
    },
};

function updateAfterIdleEventMap() {
    return Odigeo._.after(!$.fx.muted && 2, Odigeo._.bind(this.update, this));
}

module.exports = Odigeo.View.extend({
    selectors: {
        toggleDetails: '.accommodation_toggle_details',
        mapDetailsContainer: '.accommodation_details_super_container',
        mapContainer: '.accommodation_map_container',
        detailsContainer: '.accommodation_details',
        gmInfoWindow: '.gm-style-iw',
        priceDiscountInfo: '.price_discount_info',
    },

    events: {
        'tap @toggleDetails': 'accommodationToggleDetails',
        'tap .accommodation_close_hotelmapbox': 'closeHotelInfo',
        'tap @priceDiscountInfo': 'toggleDiscountBreakdownMap',
    },

    tmpls: {},

    containerHeight: 0,
    showPrices: true,
    absConfig: null,
    mapMngr: null,
    mapEvents: null,
    isUpdatedOnSearchResults: false,

    init() {
        this.listenToOnce(this.model, 'update_map', Odigeo._.bind(this.firstUpdate, this));
        this.listenTo(this.model, 'update_map', updateAfterIdleEventMap.call(this));
    },

    async firstUpdate() {
        this.absConfig = {
            hasBubbleTemplate: true,
            hasBubbleDiscountsTemplate: true,
            hasTopVisibilityMarkerPreselected: false,
            hasToggleMarkerButtons: true,
        };
        this.mapMngr = new UiGoogleMap(Odigeo._.extend({
            templates: this.tmpls,
            absConfig: this.absConfig,
            fullscreenControl: false,
        }, this.widget.options, CLUSTER_OPTIONS));
        await this.mapMngr.isReady;
        this.mapMngr.startMap({
            mapDiv: this.$cachedSelectors.mapContainer.get(0),
            btnGroupCbk: Odigeo._.bind(this.changeMarkers, this),
        });
        this.mapEvents = this.mapMngr.events.getListeners();
        this.bindMapEvents();
    },

    update() {
        this.mapMngr.setHasUserInteraction(false);
        this.model.publishMarkers(this.refreshMap());

        if (this.mapMngr.hasMarkers()) {
            this.toggleMapOnUpdate();
        } else {
            this.close();
        }
    },

    setContainerHeight(height) {
        this.containerHeight = height;
    },

    changeMarkers(eventData) {
        if (!Odigeo._.isEqual(eventData.showPrices, this.showPrices)) {
            this.showPrices = eventData.showPrices;
            this.refreshMap();
        }
    },

    toggle(evt) {
        this.toggleMap(evt, !this.isMapOpened());
    },

    toggleMap(evt, hasToOpen) {
        if (hasToOpen && this.mapMngr.events.hasMouseAction(evt)) {
            Odigeo.trigger(this.widget.id + ':openMapWithScrollAndResize');
        } else if (hasToOpen && this.isUpdatedOnSearchResults) {
            this.open();
        } else if (hasToOpen) {
            Odigeo.trigger(this.widget.id + ':openMapAndResize');
        } else {
            this.close();
        }
    },

    toggleMapOnUpdate() {
        Odigeo._.delay(Odigeo._.bind(function() {
            this.mapMngr.resizeMap({
                hasLoadedMap: this.isMapOpened(),
            });
            this.isUpdatedOnSearchResults = false;
        }, this), this.isUpdatedOnSearchResults ? 2000 : 0);
    },

    toggleAnimation(height, cbToggle) {
        return this.$cachedSelectors.mapContainer
            .clearQueue()
            .height(height)
            .delay(!$.fx.muted && 400) // .od-accommodationmap height transition duration
            .queue(Odigeo._.bind(cbToggle, this));
    },

    isMapOpened() {
        return this.$cachedSelectors.mapDetailsContainer.hasClass('map-opened');
    },

    open() {
        return this.toggleAnimation(this.getCalculatedHeight(), function(next) {
            this.mapMngr.setHasUserInteraction(false);
            this.$cachedSelectors.mapDetailsContainer.addClass('map-opened').removeClass('map-closed');
            this.mapMngr.resizeMap({hasLoadedMap: true});
            trackingUtils.trackEvent(TRACKING_ACTIONS.accommodationResults, TRACKING_LABELS.openMap);
            Odigeo.trigger(this.widget.id + ':toggleMapStatus', true);
            next();
        });
    },

    close() {
        return this.toggleAnimation(0, function(next) {
            this.$cachedSelectors.mapDetailsContainer.removeClass('map-opened loaded').addClass('map-closed');
            Odigeo.trigger(this.widget.id + ':toggleMapStatus', false);
            next();
        });
    },

    getCalculatedHeight() {
        const height = this.containerHeight - MAP_OPTIONS.offsetHeight;
        const hasToResizeMap = height > MAP_OPTIONS.minHeight;

        return hasToResizeMap ? height : MAP_OPTIONS.minHeight;
    },

    closeHotelInfo() {
        this.mapMngr.closeHotelInfo();
    },

    refreshMap() {
        return this.mapMngr.refresh({
            dataMarkers: this.model.toJSON(),
            isCustomMarker: this.showPrices,
        });
    },

    bindMapEvents() {
        const closeInfoWindow = function() {
            this.mapMngr.closeHotelInfo();
        }.bind(this);

        this.mapEvents.listenToOnce(this.mapMngr.map, {
            'idle': Odigeo._.bind(this.update, this),
        });
        this.mapEvents.listenTo(this.mapMngr.map, {
            'idle': Odigeo._.bind(function() {
                if (!this.mapMngr.hasUserInteraction) {
                    this.mapMngr.resizeMap();
                }
                this.mapMngr.setHasUserInteraction(true);
            }, this),
            'resize': Odigeo._.bind(function(options) {
                this.mapMngr.refreshBounds();
                this.$cachedSelectors.mapDetailsContainer.addClass(function() {
                    return Odigeo._.isObject(options) && options.hasLoadedMap && 'loaded';
                });
            }, this),
            'click': closeInfoWindow,
            'zoom_changed': closeInfoWindow,
        });
        this.mapEvents.listenToDom(this.mapMngr.map.getDiv(), {
            'click': Odigeo._.partial(this.mapMngr.setHasUserInteraction, true),
        });
        this.mapEvents.listenTo(this.mapMngr.getInfoWindow(), {
            'domready': !$.fx.muted ? Odigeo._.bind(this.setCardStyle, this) : Odigeo._.noop,
            'openWindowByClickOnMarker': this.onMarkerClick.bind(this),
            'clickCluster': this.onClusterClick.bind(this),
        });
        trackingUtils.bindEvents($(this.mapMngr.map.getDiv()));
    },

    accommodationToggleDetails: Odigeo._.debounce(function(evt) {
        evt.stopPropagation();
        const $target = $(evt.currentTarget);
        const isOpenHotelDetails = this.$cachedSelectors.detailsContainer.hasClass('open');
        const details = $target.data('details');
        Odigeo.trigger(`${this.widget.id}:toggleDetails`,
            $target.data('details'), this.mapMngr.getMarkerByKey(details.key).dataMarker);

        if (!isOpenHotelDetails) {
            trackingUtils.trackEvent(TRACKING_ACTIONS.accommodationResultsMap, $target.data('label'));
        }
    }, 300, true),

    updatePricesAfterRepricing(accommodationDealKey, firstRoomDealPrice, cssClass) {
        const isDetailsOpen = this.$cachedSelectors.detailsContainer.hasClass('open');

        if (isDetailsOpen) {
            const $detailsContainer = this.$el.find(this.selectors.mapDetailsContainer);
            const key = this.$el.find(this.selectors.toggleDetails).data('details').key;

            if (key === accommodationDealKey) {
                this.updateHotelBoxPrice($detailsContainer, firstRoomDealPrice, cssClass);
                this.updateDiscountLabel($detailsContainer, firstRoomDealPrice);
                this.mapMngr.updateMarkerPrice(accommodationDealKey, firstRoomDealPrice);
            }
        }
    },

    updateHotelBoxPrice($detailsContainer, firstRoomDealPrice, cssClass) {
        const $hotelRoomPriceCurrencySymbol = $detailsContainer.find('.xsell_currency_symbol');
        const $hotelRoomPriceIntPart = $detailsContainer.find('.xsell_price_int_part');
        const $hotelRoomPriceDecPart = $detailsContainer.find('.xsell_price_dec_part');
        const firstRoomDealPriceDecPart = firstRoomDealPrice.toString().split('.')[1];

        $hotelRoomPriceIntPart.text(Odigeo.Utils.splitFormatedCurrency(firstRoomDealPrice).integer);
        $hotelRoomPriceDecPart.text(Odigeo.Utils.Currency.decimalSeparator + this.getNewPriceDecPart(firstRoomDealPriceDecPart));
        $hotelRoomPriceIntPart.addClass(cssClass);
        $hotelRoomPriceDecPart.addClass(cssClass);
        $hotelRoomPriceCurrencySymbol.addClass(cssClass);
    },

    getNewPriceDecPart(firstRoomDealPriceDecPart) {
        if (Odigeo._.isUndefined(firstRoomDealPriceDecPart)) {
            return '00';
        } else if (firstRoomDealPriceDecPart.length === 1) {
            return firstRoomDealPriceDecPart + '0';
        } else {
            return firstRoomDealPriceDecPart.slice(0, 2);
        }
    },

    setCardStyle() {
        const $gmInfoWindow = this.$cachedSelectors.gmInfoWindow;
        $gmInfoWindow.css({'top': '18px'});

        const $closeButton = this.$cachedSelectors.mapContainer.find('.gm-ui-hover-effect');
        $closeButton.remove();
    },

    updateDiscountLabel($detailsContainer, firstRoomDealPrice) {
        const $originalPriceContainer = $detailsContainer.find('.xsell_price_without_discount');
        const flightPrice = $originalPriceContainer.data('flight-price');
        const originalPrice = $originalPriceContainer.data('full-price') - flightPrice;
        const newDPFareDiscount = originalPrice - (firstRoomDealPrice - flightPrice);
        const newDPFareDiscountPercentage = (newDPFareDiscount / parseFloat(originalPrice)) * 100;
        const $fareDiscountContent = $detailsContainer.find('.fare_discount_content');

        if (!Odigeo._.isUndefined(newDPFareDiscountPercentage) && !Odigeo._.isNaN(newDPFareDiscountPercentage) &&
            newDPFareDiscountPercentage >= 4.5) {
            const DPFareDiscountpercentageIntegerPart = parseInt(newDPFareDiscountPercentage, 10);
            const discountPercentageToShow = (newDPFareDiscountPercentage < DPFareDiscountpercentageIntegerPart + 0.5 ?
                newDPFareDiscountPercentage : newDPFareDiscountPercentage + 1).toFixed(0);

            $fareDiscountContent.text(`-${discountPercentageToShow}%`);
            $originalPriceContainer.removeClass('odf-hidden');
        } else {
            $fareDiscountContent.text($detailsContainer.find('.special_result_key').text());
            $originalPriceContainer.addClass('odf-hidden');
        }
    },

    onClusterClick() {
        trackingUtils.trackEvent(TRACKING_ACTIONS.accommodationResults, TRACKING_LABELS.clickCluster);
    },

    onMarkerClick(markerData) {
        const label = commonParser.buildHotelSelectOrClickLabel(markerData, TRACKING_LABELS.clickMarker, 'map');
        trackingUtils.trackEvent(TRACKING_ACTIONS.accommodationResultsMap, label);
    },

    toggleDiscountBreakdownMap: Odigeo._.debounce(function(evt) {
        $(evt.target).parent().toggleClass('open');
        evt.stopPropagation();
    }, 500, {leading: true}),
});
